import { Box } from '@mui/system';
import LayerToggle from '../../../common-components/layer-toggle/layer-toggle';
import { VesselOption } from '../../../models/my-fleet.model';
import { ProAlert } from '../../../models/pro.model';
import MyFleetVesselAlertToggle from './my-fleet-vessel-alerts-button';
import MyFleetVesselMoreOptions from './my-fleet-vessel-options-button';

interface MyFleetVesselItemButtonsProps {
  showAlertToggle?: boolean;
  proAlert?: ProAlert | null;
  showLayerToggle?: boolean;
  showMoreOptions?: boolean;
  onOptionSelection: (optionType: VesselOption) => void;
  onDeleteAlert: (alert_id: string) => void;
  vesselImo?: string | null;
}

function MyFleetVesselItemButtons({
  showAlertToggle,
  proAlert,
  showLayerToggle,
  showMoreOptions,
  onOptionSelection,
  onDeleteAlert,
  vesselImo,
}: MyFleetVesselItemButtonsProps) {
  return (
    <Box
      sx={{
        position: 'absolute',
        right: 12,
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '2px',
      }}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      data-testid="my-fleet-item-buttons"
      aria-label="My Fleet Item Buttons"
    >
      {showAlertToggle && (
        <MyFleetVesselAlertToggle proAlert={proAlert} vesselImo={vesselImo} />
      )}
      {showLayerToggle && <LayerToggle layers={[]} layerGroups={[]} />}
      {showMoreOptions && (
        <MyFleetVesselMoreOptions
          onOptionSelection={onOptionSelection}
          proAlertId={proAlert?.alert_id}
          onDeleteAlert={onDeleteAlert}
          vesselImo={vesselImo}
        />
      )}
    </Box>
  );
}

export default MyFleetVesselItemButtons;

MyFleetVesselItemButtons.defaultProps = {
  showAlertToggle: false,
  proAlert: null,
  showLayerToggle: false,
  showMoreOptions: true,
  vesselImo: null,
};
